import * as React from 'react';
import BaseSettingsTeamLayout from './BaseSettingsTeamLayout';
import ConfirmUserPopup from '../containers/users/ConfirmUserPopup';

export default (params) => {
  const { userId } = params;

  return BaseSettingsTeamLayout(
    <ConfirmUserPopup userId={userId} title="Delete user!" />
  );
};
